import * as React from 'react';
import { createSelectable, TSelectableItemProps } from '../../../../components/drag-select';
import { OrderSummary } from '../../../../transportation/models/shared/order-summary';

// The actual contract of this control.
//
// The TS compiler isn't working with the drag
// library we use so we're falling back to props
// of any in order to compile.
interface IProps extends TSelectableItemProps {
    orderItem: OrderSummary;
    showExtraColumns: boolean;
}

export const SelectableOrderRow = (props : any) => {

    const { selectableRef, 
        isSelected, 
        isSelecting, 
        orderItem,
        showExtraColumns
     } = props;

     let actualClass = 'order-selectable';
     actualClass += (orderItem.isChecked) ? ' highlight' : '';
     actualClass += (isSelecting) ? ' dragging' : '';
     actualClass += (isSelected) ? ' selected-already' : '';
        
    return orderItem 
            ? <tr key={orderItem.id} 
                ref={selectableRef} 
                className={ actualClass }>
                <td>
                    <input
                        type="checkbox"
                        checked={orderItem.isChecked}
                        onChange={() => { return; }}
                    />
                </td>
                <td>{ orderItem.id }</td>
                <td>{ orderItem.quantity }</td>
                <td>{ orderItem.description }</td>
                <td>{ orderItem.jobName }</td>
                <td>{ orderItem.units }</td>
                <td>{ orderItem.weight }</td>
                <td>{ orderItem.singles }</td>
                <td>{ orderItem.feet }</td>
                {
                    showExtraColumns
                        ? <React.Fragment>
                                <td>{ orderItem.sections } </td>
                                <td>{ orderItem.track }</td>
                                <td>{ orderItem.hardware }</td>
                            </React.Fragment>
                        : null                        
                }
            </tr>
        : <tr/>;

};

export default createSelectable(SelectableOrderRow);
